import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import React, { useState } from 'react';
import { FaTimes, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import { Swipeable } from 'react-swipeable';

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;
var styles = {
  "popUp": "_1IQhR",
  "popUpBackground": "_3evcv",
  "show": "_1g7xd",
  "popUpContent": "_1bVVd",
  "closeIconContainer": "_2vPZB"
};

var PopUp = function PopUp(_ref) {
  var forceShowPopUp = _ref.forceShowPopUp,
      forceClosePopUp = _ref.forceClosePopUp,
      children = _ref.children;

  var _useState = useState(false),
      showPopUp = _useState[0],
      setShowPopUp = _useState[1];

  return /*#__PURE__*/React.createElement("div", {
    className: styles.popUp + " embrk-pop-up"
  }, /*#__PURE__*/React.createElement("div", {
    className: showPopUp || forceShowPopUp ? styles.popUpBackground + " " + styles.show : styles.popUpBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.popUpContent + " embrk-pop-up-content"
  }, children, /*#__PURE__*/React.createElement("div", {
    className: styles.closeIconContainer
  }, /*#__PURE__*/React.createElement(FaTimes, {
    onClick: function onClick() {
      setShowPopUp(false);
      forceClosePopUp && forceClosePopUp();
    }
  })))));
};

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

var styles$1 = {
  "tabsContainer": "_lCB_D",
  "tabs": "_3t_g6",
  "tabsHeaderContainer": "_1vvLR",
  "tabsHeader": "_2D8ET",
  "tabTitles": "_2pXEI",
  "tabTitle": "_1Whix",
  "selected": "_w5lRQ",
  "underlineContainer": "_33imo",
  "tabsUnderline": "_zsGpA",
  "tabsBody": "_1RczJ",
  "tabContent": "_1G1aj",
  "left": "_2bi7Y",
  "center": "_3hv6Z",
  "right": "_3m0BO"
};

var _temp;

var Tabs = (_temp = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.selectTab = function (index) {
      _this.setState({
        activeTab: index
      });

      _this.underlineRef.current.style.left = _this.titleRefs[index].offsetWidth * index + "px";
    };

    _this.state = {
      activeTab: 0
    };
    _this.underlineRef = React.createRef();
    _this.tabsBodyRef = React.createRef();
    _this.titleRefs = [];
    _this.bodyRefs = [];

    if (props.defaultTab && props.defaultTab < props.children.length) {
      _this.state.activeTab = props.defaultTab;
    }

    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.selectTab(this.state.activeTab);
    var maxHeight = 0;

    for (var _iterator = _createForOfIteratorHelperLoose(this.bodyRefs), _step; !(_step = _iterator()).done;) {
      var bodyRef = _step.value;
      maxHeight = bodyRef.offsetHeight > maxHeight ? bodyRef.offsetHeight : maxHeight;
    }

    this.bodyRefs.map(function (ref) {
      return ref.style.position = "absolute";
    });
    this.tabsBodyRef.current.style.height = maxHeight + "px";
    this.tabsBodyRef.current.style.display = "flex";

    if (this.props.boldTitlePortions) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.titleRefs), _step2; !(_step2 = _iterator2()).done;) {
        var titleRef = _step2.value;

        for (var _iterator3 = _createForOfIteratorHelperLoose(this.props.boldTitlePortions), _step3; !(_step3 = _iterator3()).done;) {
          var portion = _step3.value;

          if (titleRef) {
            titleRef.innerHTML = titleRef.innerHTML.replace(portion, '<strong>' + portion + '</strong>');
          }
        }
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      className: styles$1.tabsContainer + " embrk-tabs"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1.tabs
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1.tabsHeaderContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1.tabsHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1.tabTitles
    }, this.props.titles.map(function (title, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: index === _this2.state.activeTab ? styles$1.tabTitle + " " + styles$1.selected : styles$1.tabTitle,
        onClick: function onClick() {
          return _this2.selectTab(index);
        },
        ref: function ref(_ref) {
          _this2.titleRefs && (_this2.titleRefs[index] = _ref);
          return true;
        }
      }, title);
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$1.underlineContainer
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.underlineRef,
      className: styles$1.tabsUnderline
    })))), /*#__PURE__*/React.createElement("div", {
      ref: this.tabsBodyRef,
      className: styles$1.tabsBody
    }, this.props.children.map(function (child, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: index === _this2.state.activeTab ? styles$1.tabContent + " " + styles$1.center : index > _this2.state.activeTab ? styles$1.tabContent + " " + styles$1.right : styles$1.tabContent + " " + styles$1.left,
        style: {
          width: "100%"
        },
        ref: function ref(_ref2) {
          _this2.bodyRefs && (_this2.bodyRefs[index] = _ref2);
          return true;
        }
      }, /*#__PURE__*/React.createElement("div", null, child));
    }))));
  };

  return Tabs;
}(React.Component), _temp);
var styles$2 = {
  "slidesContainer": "_1x-Ws",
  "slides": "_1SZyY",
  "slidesBody": "_14zIc",
  "arrowContainer": "_3hEEp",
  "slideContainer": "_31Nn7",
  "slideContent": "_29l9O",
  "left": "_twa3n",
  "center": "_hV8Ko",
  "right": "_eR3ei"
};

var Slider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      activeSlide: 0
    };
    _this.slidesBodyRef = React.createRef();
    _this.slideRefs = [];
    return _this;
  }

  var _proto = Slider.prototype;

  _proto.decrementCurrentSlide = function decrementCurrentSlide() {
    var rightSlideIndex = this.state.activeSlide === this.props.children.length - 1 ? 0 : this.state.activeSlide + 1;
    var right = this.slideRefs[rightSlideIndex];
    right.style.display = "none";
    setTimeout(function () {
      return right.style.display = "flex";
    }, 350);

    if (this.state.activeSlide === 0) {
      this.setState({
        activeSlide: this.props.children.length - 1
      });
    } else {
      this.setState({
        activeSlide: this.state.activeSlide - 1
      });
    }
  };

  _proto.incrementCurrentSlide = function incrementCurrentSlide() {
    var leftSlideIndex = this.state.activeSlide === 0 ? this.props.children.length - 1 : this.state.activeSlide - 1;
    var left = this.slideRefs[leftSlideIndex];
    left.style.display = "none";
    setTimeout(function () {
      return left.style.display = "flex";
    }, 550);

    if (this.state.activeSlide === this.props.children.length - 1) {
      this.setState({
        activeSlide: 0
      });
    } else {
      this.setState({
        activeSlide: this.state.activeSlide + 1
      });
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var maxHeight = 0;
    var maxWidth = 0;

    for (var _iterator = _createForOfIteratorHelperLoose(this.slideRefs), _step; !(_step = _iterator()).done;) {
      var slideRef = _step.value;
      maxHeight = slideRef.offsetHeight > maxHeight ? slideRef.offsetHeight : maxHeight;
      maxWidth = slideRef.offsetWidth > maxWidth ? slideRef.offsetWidth : maxWidth;
    }

    this.slideRefs.map(function (ref) {
      return ref.style.position = "absolute";
    });
    this.slidesBodyRef.current.style.height = maxHeight + "px";
    this.slidesBodyRef.current.style.width = maxWidth + "px";
    this.slidesBodyRef.current.style.display = "flex";
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      className: styles$2.slidesContainer + " embrk-slider"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2.slides
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2.slidesBody
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2.arrowContainer,
      onClick: function onClick() {
        return _this2.decrementCurrentSlide();
      }
    }, /*#__PURE__*/React.createElement(IconContext.Provider, {
      value: {
        size: "37px"
      }
    }, /*#__PURE__*/React.createElement(FaAngleLeft, null))), /*#__PURE__*/React.createElement("div", {
      ref: this.slidesBodyRef,
      className: styles$2.slideContainer
    }, this.props.children.map(function (child, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: index === _this2.state.activeSlide ? styles$2.slideContent + " " + styles$2.center : index === _this2.state.activeSlide + 1 || _this2.state.activeSlide === _this2.props.children.length - 1 && index === 0 ? styles$2.slideContent + " " + styles$2.right : styles$2.slideContent + " " + styles$2.left,
        ref: function ref(_ref) {
          _this2.slideRefs && (_this2.slideRefs[index] = _ref);
          return true;
        }
      }, /*#__PURE__*/React.createElement(Swipeable, {
        onSwipedLeft: function onSwipedLeft() {
          return _this2.incrementCurrentSlide();
        },
        onSwipedRight: function onSwipedRight() {
          return _this2.decrementCurrentSlide();
        }
      }, /*#__PURE__*/React.createElement("div", null, child)));
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$2.arrowContainer,
      onClick: function onClick() {
        return _this2.incrementCurrentSlide();
      }
    }, /*#__PURE__*/React.createElement(IconContext.Provider, {
      value: {
        size: "37px"
      }
    }, /*#__PURE__*/React.createElement(FaAngleRight, null))))));
  };

  return Slider;
}(React.Component);

var styles$3 = {
  "accordion": "_u2_D0",
  "accordionRow": "_1YGA4",
  "accordionRowHeader": "_1adjZ",
  "expandButton": "_3sU2n",
  "minus": "_17LPj",
  "accordionRowBody": "_1vko9",
  "hide": "_2ji2G"
};

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Accordion, _React$Component);

  function Accordion(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      openRow: 0
    };
    _this.accordionRef = React.createRef();
    _this.bodyRefs = [];
    return _this;
  }

  var _proto = Accordion.prototype;

  _proto.componentDidMount = function componentDidMount() {
    for (var _iterator = _createForOfIteratorHelperLoose(this.bodyRefs), _step; !(_step = _iterator()).done;) {
      var bodyRef = _step.value;
      bodyRef.style.setProperty("--accordion-max-height", bodyRef.scrollHeight + "px");
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      ref: this.accordionRef,
      className: styles$3.accordion + " embrk-accordion"
    }, this.props.children.map(function (child, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.accordionRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.accordionRowHeader,
        onClick: function onClick() {
          return index === _this2.state.openRow ? _this2.setState({
            openRow: null
          }) : _this2.setState({
            openRow: index
          });
        }
      }, _this2.props.headers[index], /*#__PURE__*/React.createElement("div", {
        className: index == _this2.state.openRow ? styles$3.expandButton : styles$3.expandButton + " " + styles$3.minus
      })), /*#__PURE__*/React.createElement("div", {
        className: index == _this2.state.openRow ? styles$3.accordionRowBody + " " + styles$3.show : styles$3.accordionRowBody + " " + styles$3.hide,
        ref: function ref(_ref) {
          _this2.bodyRefs && (_this2.bodyRefs[index] = _ref);
          return true;
        }
      }, child));
    }));
  };

  return Accordion;
}(React.Component);

export { Accordion, PopUp, Slider, Tabs };